"use client"

import "../lib/cookieScript"

interface CookiePreferencesButtonProps {
  name: string
  className?: string
}

const DEFAULT_CLASS =
  "cursor-pointer text-left text-base whitespace-nowrap focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"

export const CookiePreferencesButton = ({
  name,
  className,
}: CookiePreferencesButtonProps) => {
  const handleClick = () => {
    if (typeof window === "undefined") {
      return
    }
    window.CookieScript?.instance?.show?.()
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Open cookie preferences"
      className={className ?? DEFAULT_CLASS}
    >
      {name}
    </button>
  )
}
